import { faqItems } from '@/mocks/home';

export default function FAQ() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          常见问题
        </h2>
        <div className="max-w-[800px] mx-auto flex flex-col gap-4">
          {faqItems.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6">
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="inline-flex items-center justify-center w-6 h-6 md:w-7 md:h-7 rounded-full bg-primary-100 text-primary-600 text-xs font-bold flex-shrink-0 mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9 md:pl-10">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}